/* cji-recently-viewed, 21 September 2026.

   From a Clarity session on a PAID click. The visitor chose a ring size, added
   to bag, then clicked through "Recently viewed products" and landed straight
   back on the page they were already reading. They did it at 116 seconds into
   a 177 second visit and left without checking out.

   The theme writes the CURRENT product into recentlyViewedProduct in
   localStorage and then renders the whole list, so on a first visit that
   section holds exactly one card: the page you are standing on. Clicking it
   reloads the same page, which is a dead end wearing the clothes of a
   suggestion.

   Two rules, both obvious once seen:
     a product is never "recently viewed" while you are looking at it
     a section with nothing left in it should not show its heading

   Done here rather than in custom-async.js because that file is the theme
   vendor's and a theme update would put the bug back. Everything is wrapped:
   if this throws, the shopper gets the section as it was. */
(function () {
  'use strict';
  try {
    if (!/\/products\//.test(location.pathname)) return;
    var here = location.pathname.replace(/\/+$/, '');

    function tidy() {
      try {
        var secs = document.querySelectorAll('.recently-viewed-products');
        for (var i = 0; i < secs.length; i++) {
          var s = secs[i];
          var links = s.querySelectorAll('a[href*="/products/"]');
          for (var j = 0; j < links.length; j++) {
            var href = (links[j].getAttribute('href') || '').split('?')[0].replace(/\/+$/, '');
            if (href !== here) continue;
            var card = links[j].closest('li') || links[j].closest('[class*="item"]');
            if (card && card.parentNode) { card.parentNode.removeChild(card); }
          }
          var left = s.querySelectorAll('a[href*="/products/"]').length;
          if (left === 0) {
            s.style.setProperty('display', 'none', 'important');
          } else {
            s.style.removeProperty('display');
          }
        }
      } catch (e) { /* a tidy up is not worth a broken page */ }
    }

    /* The list is written by the theme's own async script well after load, and
       the product section is re-rendered on a variant change, so one pass at
       DOMContentLoaded would miss both.

       THROTTLED, NOT DEBOUNCED, and that distinction is the whole bug. The
       first version cleared and reset a 120ms timer on every mutation. This
       page fires one about every 125ms, so the timer was reset just before it
       was due, over and over, and tidy() never ran at all. The logic was
       right and simply never executed. A throttle runs on the leading edge and
       guarantees a trailing pass, so a busy page makes it run MORE, not less. */
    var lastRun = 0, pending = null;
    function schedule() {
      var now = Date.now();
      if (now - lastRun > 300) { lastRun = now; tidy(); return; }
      if (pending) return;
      pending = setTimeout(function () {
        pending = null; lastRun = Date.now(); tidy();
      }, 300);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedule);
    } else { schedule(); }
    window.addEventListener('recentlyViewedProducts', schedule);
    /* fixed passes as well, for the case where nothing mutates after the list
       is written and no observer callback ever arrives */
    [300, 900, 1800, 3000].forEach(function (ms) { setTimeout(tidy, ms); });
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  } catch (e) { /* as above */ }
})();
